import React, { useState } from 'react';
import { DataList, Loader } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import useService from '../../utils/useService';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';

import { columnConfigs } from './listConfig';

const WalletList: React.FC<{}> = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		setShowLoader
	});
	const actions = getActionList();

	const { getCsvDetails } = useService();

	return (
		<>
			{showLoader && <Loader />}
			<DataList
				fetchData={getCsvDetails}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.WALLET}
				initialSortDirection='ASC'
				initialSortIndex={0}
			/>
		</>
	);
};

export default WalletList;
